import { hexToRGB } from '../utils/helper.js'
import axios from 'axios'
import pick from 'lodash/pick'
import omit from 'lodash/omit'
import each from 'lodash/each'
import cloneDeep from 'lodash/cloneDeep'

const allowedConfigOverride = [
  'hideControls',
  'mute',
  'videoId',
  'videoUrl',
  'volume',
]

const acceptedConfigKeys = ['allowFullscreen', 'aspectratio', 'audioOnly', 'autoplay',
  'controls', 'height', 'hiddenControls', 'mute', 'quality', 'repeat', 'responsive', 'shareUrl',
  'showChapters', 'showDescription', 'showTitle', 'stretching', 'skinThemeColour', 'volume',
  'width', 'slideSeeking', 'maxSeek', 'presentationMode', 'lang', 'skin',
  'gaId', 'aspectratioX', 'aspectratioY', 'themeColour', 'themeColourChecked', 'socialshare', 'interactiveShowScrub',
  'interactiveShowTimestamp', 'theaterMode', 'interactiveFullscreenButtonPosition', 'noCustomCss', 'externalFullscreen',
  'textTrackBackground'
]

export let ConfigManager = {
  updateConfig(oldConfig, newConfig) {
    var updatedConfig = cloneDeep(oldConfig)
    each(pick(newConfig, allowedConfigOverride), (value, key) => {
      updatedConfig[key] = value
    })
    return updatedConfig;
  },
  mergeTemplateConfig(templateConfig, keysToOmit, currentConfig) {
    templateConfig = pick(templateConfig, acceptedConfigKeys);
    if (!(keysToOmit instanceof Array)) {
      keysToOmit = Object.keys(keysToOmit);
    }
    templateConfig = omit(templateConfig, keysToOmit);
    if (templateConfig === {}) {
      return
    }
    if (typeof templateConfig.hideControls === 'string') {
      templateConfig.hideControls = templateConfig.hideControls.split(',');
    }
    if (templateConfig.aspectratio) {
      templateConfig.aspectratio = templateConfig.aspectratioX + ':' + templateConfig.aspectratioY;
    }
    if (templateConfig.responsive) {
      delete templateConfig.width;
      delete templateConfig.height;
    }
    if (templateConfig.themeColourChecked) {
      templateConfig.skin = {
        controlbar: {
          text: templateConfig.themeColour,
          icons: hexToRGB(templateConfig.themeColour, 0.8),
          iconsActive: templateConfig.themeColour
        },
        timeslider: {
          progress: templateConfig.themeColour
        }
      }
    }

    if (typeof currentConfig.skin !== 'undefined') {
      templateConfig.skin = currentConfig.skin;
    }

    if (templateConfig.audioOnly) {
      templateConfig.height = 40;
    }
    return templateConfig;
  }
}
